/**
 * Section configuration
 */
module.config(['$stateProvider', function ($stateProvider) {
    'use strict';
    $stateProvider
        .state('404', {
            url: '/404', // TODO : translate or not ?
            controller: ['$scope', '$rootScope', '$document', 'headermanager', function ($scope, $rootScope, $document, $headermanager) {
                $document.find('body').addClass('is-notfound');

                $headermanager.customize({
                    filled: true
                });

                $scope.$on('$destroy', function () {
                    $document.find('body').removeClass('is-notfound');
                });
            }],
            template:
            '<div class="aqua-notfound grid grid-v grid-center">' +
            '  <div class="grid-main grid grid-v grid-center">' +
            '    <div class="aqua-notfound--panel grid grid-v">' +
            '      <h1 class="aqua-notfound--title">La page que vous cherchez n\'existe pas ou n\'existe plus.</h1>' +
            '      <p class="aqua-notfound--code">Erreur : 404</p>' +
            '      <p class="aqua-notfound--pre-message">Pas de voile en vue...<br>Mais aux Glénans il est possible de retrouver le chemin du port.</p>' +
            '      <p class="aqua-notfound--message">Retrouver le chemin de Glénans Avenir</p>' +
            '    </div>' +
            '    <p class="aqua-notfound--action"><a ui-sref="homepage" class="aqua-notfound--button">Retour à l\'accueil</a></p>' +
            '  </div>' +
            '</div>'
        });
}]);
